import MoneyService from "../services/MoneyService";

const checkReceipt = async (qrString) => {
  try {
    // Since MoneyService.verifyReceipt expects an object, ensure qrString is an object
    const response = await MoneyService.verifyReceipt(qrString);

    console.log(response.data);
    return response.data; 
  } catch (err) {
    console.error(err.response ? err.response.data : err.message);
  }
}



export default checkReceipt;
